import React from "react";

const AddressChange = () => {
  return (
    <div>
      <h1>Address Change</h1>
    </div>
  );
};

export default AddressChange;
